
import { defineComponent, ComputedRef, computed, watch, ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { AddressEdit } from 'vant'
import { AddressEditInfo } from '@/types/address'
import getCacheUserAddressInfo from '@/compositions/userAddress'
import { areaList } from '@vant/area-data'
import { useStore } from 'vuex'
import { copy } from '@/utils/index'
import getCacheFaultBillInfo from '@/compositions/fault/device'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Fault-Address',
  components: {
    AppHeader,
    VanAddressEdit: AddressEdit,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const guid: ComputedRef<string> = computed(() => {
      return store.getters.userGuid
    })
    const addressInfo = ref({})
    const { setReceiveAddress } = getCacheFaultBillInfo()
    const { userAddressInfo, setUserAddress } = getCacheUserAddressInfo()
    const initAddressInfo = () => {
      if (userAddressInfo.value) {
        addressInfo.value = copy(userAddressInfo.value)
      }
    }
    watch(userAddressInfo, () => {
      initAddressInfo()
    })
    initAddressInfo()
    const onSave = (item: AddressEditInfo) => {
      setUserAddress({ userGuid: guid.value, addressInfo: item })
      setReceiveAddress(item)
      router.go(-1)
    }
    return {
      addressInfo,
      areaList,
      onSave,
    }
  },
})
